export default {
  getCategoryCampaign: state => state.categoryCampaign,
  searchCampaign: state => state.searchCampaign,
  urgentCampaign: state => state.urgentCampaign,
  popularCampaign: state => state.popularCampaign,
  campaign: state => {
    if (state.campaign.length < 0) {
      return state.defaultCampaign
    }

    return state.campaign
  },
  totalCampaign: state => state.totalCampaign,
  detail: state => id => state.campaign.find(item => item.id == id),
  detailZxCare: state => id => state.zxCareCampaign.find(item => item.id == id),
  zxCareCampaign: state => state.zxCareCampaign
}